import React, { createContext, useContext, useState } from 'react';

const PortalContainer = createContext<HTMLDivElement | null>(null);

export function usePilotPortal(): HTMLDivElement | undefined {
  return useContext(PortalContainer) ?? undefined;
}

export function PilotTheme({ children }: { children: React.ReactNode }) {
  const [portal, setPortal] = useState<HTMLDivElement | null>(null);
  return (
    <PortalContainer.Provider value={portal}>
      <div className="pilot-theme">
        {children}
        <div ref={setPortal} data-pilot-portal="" />
      </div>
    </PortalContainer.Provider>
  );
}
